import { Injectable } from '@angular/core';
import { TabService } from '../tab/tab.service';
import { CommsService } from '../comms/comms.service';
import { DisplayService } from '../display/display.service';
import { ConfigService } from '../config/config.service';
import { DataService } from '../data/data.service';
import { DataTableService } from '../dataTable/dataTable.service';

@Injectable()
export class DtvScheduleService {

	constructor(
		private tabService: TabService,
		private commsService: CommsService,
		private displayService: DisplayService,
		private configService: ConfigService,
		private dataService: DataService,
		private dataTableService: DataTableService
		) { }

	dataObj = 'dtvschedule';

	tabsData = {
		listTabs: [
			{
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			},
		]
	};

	loadAllForTab() {

	}

	// TABBING METHODS

	getActiveTab(tabsData): any {
		let activeTab = {};
		tabsData.forEach((d) => {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp, tabsData, type) {
		tabsData.forEach((d) => {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				if (d.listTab) {
					this.loadSchedulesForTab(d);
				}
			}
		});
	}

	selectDefaultTab(tabsData) {
		tabsData.forEach((d, i) => {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach((d, i) => {
			console.log('CHECK TAB FOR DEFAULT', d, this.tabService.showTab(d.persona, d.notPersona));
			if (this.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				this.loadSchedulesForTab(d);
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		tabsData.forEach((d, i) => {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				this.loadSchedulesForTab(d);
			}
		});
	}

	showTabSearch(tabsData) {
		this.getActiveTab(tabsData)['searching'] = !this.getActiveTab(tabsData)['searching'];
	}

	checkTabs(tabsData) {
		// expected method, no logic needed for po page tabs
		// see same method in contractorService for example of use
	}

	tableSort(event) {
		this.dataTableService.tableSort(event, this.getActiveTab(this.tabsData.listTabs), (tab) => this.loadSchedulesForTab(tab));
	}

	loadSchedulesForTab(tab) {
		if (tab.prop === 'all') {
			this.loadSchedules(tab);
		}
	}

	loadSchedules(data) {
		// this.displayService.startLoading();
		this.displayService.activateLoadingTab(data, this.tabsData.listTabs);
		this.commsService.getScheduleDTVs(data).subscribe((dtvRes) => {
			// this.displayService.endLoading();
			this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			const successData = this.commsService.getSuccessData(dtvRes);
			const count = this.commsService.getSuccessCount(dtvRes);
			const scheduledDTVs = this.configService.getTableData(successData, this.dataObj);

			const dataRef = this.dataObj + '-' + data.prop + '-' + data.type;
			this.dataService.updatePageData(dataRef, data, scheduledDTVs);
			this.dataService.updateDataCount(dataRef, count);
		}, (err) => {
			// this.displayService.endLoading();
			this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			this.commsService.handleAPIError('', err);
		});
	}

}
